import { Navigate, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';

import Header from './components/Header/Header.jsx';
import NavBar from './components/Nav-Bar/Nav-Bar.jsx';
import Footer from './components/Footer/Footer.jsx';

import Home from './components/Pages/Home/Home.jsx';
import Giving from './components/Pages/Giving/Giving.jsx';
import Story from './components/Pages/Story/Story.jsx';
import Find from './components/Pages/Find/Find.jsx';
import Product from './components/Pages/Product/Product.jsx';
import NotFound from './components/Pages/404/Not-Found.jsx';

import PageTransition from './components/PageStyling/PageTransition.jsx';
import ScrollToTop from './components/PageStyling/ScrollToTop.jsx';

import './App.css';

function App() {
    const location = useLocation(); 

    return (
        <ScrollToTop>
            <Header />
            <NavBar />
            
            <AnimatePresence>
                <Routes location={location} key={location.pathname}>
                    <Route path='/' element={<PageTransition><Navigate to='/home' /></PageTransition> } />
                    <Route path='/home' element={<PageTransition><Home /></PageTransition>} />
                    <Route path='/giving' element={<PageTransition><Giving /></PageTransition>} />
                    <Route path='/story' element={<PageTransition><Story /></PageTransition>} />
                    <Route path='/find' element={<PageTransition><Find /></PageTransition>} />
                    <Route path='/product-information' element={<PageTransition><Product /></PageTransition>} />
                    <Route path="*" element={<PageTransition><NotFound /></PageTransition>} />
                </Routes>
            
            </AnimatePresence>
        <Footer />
        </ScrollToTop>
    );
}

export default App;
